module.exports = {
    INSURANCE_HOME: 'insuranceHome',
    INSURANCE_LIFE: 'insuranceLife',
    ROBO_MOVIL: 'roboMovil',
};
